module.exports = __webpack_public_path__ + "img/login-icon-monitor.8669b944.png";